import { type Ref } from 'react';
import { Label, Error, Icon, ClassHelper } from 'components/lib';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker, { type Day, type RenderInputProps } from '@hassanmojab/react-modern-calendar-datepicker';
import InputStyle from '../input.tailwind.js';
import Style from './date.module.scss';

interface DateInputProps {
  value?: string;
  required?: boolean;
  onChange: (name?: string, value?: string, valid?: boolean) => void;
  name?: string;
  valid?: boolean;
  placeholder?: string;
  label?: string;
  min?: Day;
  max?: Day;
  errorMessage?: string;
}

export function DateInput(props: DateInputProps) {
  // init default value
  let date: Day;

  if (props.value && props.value.indexOf('-') && props.value.length >= 10) {
    const parts = props.value.split('-');

    date = {
      year: parseInt(parts[0]),
      month: parseInt(parts[1]),
      day: parseInt(parts[2]),
    };
  } else {
    const now = new Date();
    date = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
  }

  function formatDateString(d: Day) {
    return `${d.year}-${d.month < 10 ? '0' + d.month : d.month}-${d.day < 10 ? '0' + d.day : d.day}`;
  }

  function change(date: Day) {
    let valid;

    if (props.required) valid = date.year && date.day && date.month ? true : false;

    props.onChange(props.name, formatDateString(date), valid);
  }

  const dateStyle = ClassHelper(InputStyle, {
    textbox: true,
    error: props.valid === false,
    success: props.valid === true,
  });

  function customInput({ ref }: RenderInputProps) {
    return (
      <input
        ref={ref as Ref<HTMLInputElement>}
        value={props.value?.split('T')[0]}
        placeholder={props.placeholder || 'Please select a date'}
        className={dateStyle}
      />
    );
  }

  return (
    <div className={InputStyle.input}>
      {props.label && <Label text={props.label} required={props.required} for={props.name} />}

      <DatePicker
        value={date}
        onChange={change}
        minimumDate={props.min}
        maximumDate={props.max}
        colorPrimary="#73B0F4"
        wrapperClassName={Style.date}
        renderInput={customInput}
        calendarPopperPosition="bottom"
      ></DatePicker>

      {props.valid === false && <Error message={props.errorMessage || 'Please select a date'} />}

      {props.valid === true && <Icon image="check" color="#8CC57D" className={InputStyle.successIcon} size={16} />}
    </div>
  );
}
